import { DeprecationService } from "../sdServices/deprecationSvc";

// @ngInject
export let deprecationDirective = function (deprecationService: DeprecationService) {
  return {
    restrict: "E",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: any) {
      deprecationService.logDeprecationMessage(attr.message);
    }
  };
};
